// extracted by mini-css-extract-plugin
export default {"checkboxList":"CheckboxList_checkboxList__-l9ct","label":"CheckboxList_label__kNcAz","checkbox":"CheckboxList_checkbox__tDV-K"};